import { type ReactNode, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useImpersonate } from '@/contexts/ImpersonateContext';
import { isCertificationUnlocked } from '@/lib/certification-lock';
import { CertificationCodeDialog } from './CertificationCodeDialog';

/** Garde des écrans de la rubrique Certification : code demandé aussi en accès direct par l'adresse. */
export function CertificationGate({ children }: { children: ReactNode }) {
  const navigate = useNavigate();
  const { userRole } = useAuth();
  const { isImpersonating } = useImpersonate();
  const [unlocked, setUnlocked] = useState(isCertificationUnlocked);
  if (unlocked || userRole === 'super_admin' || isImpersonating) return <>{children}</>;
  return (
    <CertificationCodeDialog
      open
      onOpenChange={(open) => {
        if (!open) navigate('/', { replace: true });
      }}
      onUnlock={() => setUnlocked(true)}
    />
  );
}
